/* eslint eqeqeq: "off" */
import React from 'react';
import {connect} from 'react-redux';
import CursoView from './CursoView';
import {bindActionCreators} from 'redux';
import * as tagActions from '../../actions/tagActions';
import * as formularioActions from '../../actions/formularioActions';
import * as resultadoexamenActions from '../../actions/resultadoexamenActions';
import * as comentariosActions from '../../actions/comentariosActions';
import * as contenidoActions from '../../actions/contenidoActions';
//import CustomInput from './CustomInput'
import * as crucigramapalabrasActions from '../../actions/crucigramapalabrasActions';

import {  useParams } from "react-router-dom";
import {  useLocation, useNavigate  } from "react-router-dom";
import withRouter from '../common/withRouter';
import toastr from 'toastr';
import ManageList from '../common/ManageList';

import { Segment, Header} from 'semantic-ui-react';
import ModalSiNo from '../common/ModalSiNo';
import $ from 'jquery';
import * as showSidebarIzquierdaActions from '../../actions/showSidebarIzquierdaActions';
import * as cursoActions from '../../actions/cursoActions';
import * as Resultado from '../common/Resultado';

import * as infoActions from '../../actions/infoActions';


import {usuarioActual, renuevaToken, validaApiToken} from '../../util';
import * as userActions from '../../actions/userActions';
import * as paginaActions from '../../actions/paginaActions';
import * as menuActions from '../../actions/menuActions';

import {getMargenes} from '../../util/';
import moment from 'moment';



import RichTextEditor from 'react-rte';

class ManageCursoView extends React.Component {
    constructor(props, context) {
		
		super(props, context);
    
        this.state={
            errors:{},
            strings:{},
            curso:{
                 modulos:[]
             },
            modulos:[],
            showActivos:true,
            showModal:false,
            filtrosCombo:{},
            permisos:{},
            examenSave:{
                cadena:[]
            },
            quiz:{
                
                questions:[]
            },
            err:null,
            appLocale:{
                "singleSelectionTagText":"Seleccion simple",    
                "multipleSelectionTagText":"Selección multiple",  
                "pickNumberOfSelection":"Selecciona <numberOfSelection>",
                "resultPagePoint": "Obtuviste <correctPoints> de un total de <totalPoints>.",
                "landingHeaderText": "La siguiente prueba consta de <questionLength> Preguntas",
                "question": "Pregunta",
                "startQuizBtn": "Comenzar prueba",
                "resultFilterAll": "All",
                "resultFilterCorrect": "Correct",
                "resultFilterIncorrect": "Incorrect",
                "nextQuestionBtn": "Siguiente",
                "resultPageHeaderText": "Tu has completado la prueba. Tuviste <correctIndexLength> correctas de <questionLength> preguntas."
                } ,
            comentarios:[],
            reply:0,
            edit:0,
            editReply:0,
            indexReply:-1,
            indexComentario:-1,
            textComment:"",
            visible:true, 
            fechaActual: new moment(),
            tiempoVideo:0,
            value: RichTextEditor.createEmptyValue(),
            fechaComentario:new moment().subtract(5, "days"),
            botonComentario:false,
            datatmp:{
                across:{},
                down:{}
            },
            
            dataCrucigrama:{
              across: {},
              down: {}
            },
            
            dataArray:[
              
            ]
		};
	}

    
    
    
    
	componentDidMount(){
        
        
       usuarioActual(this, "cursoview",true).then( (usuario)=>{
           	let id=this.props.id;
        

            this.props.showSidebarIzquierdaActions.sidebarIzquierda(true);
        
            if(id && id>0 ){
            
          
                
            this.props.infoActions.getCursoDetalleInfo(id).then( (cursoDetalle)=>{
            let modulos=cursoDetalle.modulos;
            let contenido;
            let agrupador="";
            let fecha="";
            let contenidoViewRow={};
            let contenidoView=[];
            for(let k=0; k<modulos.length; k++){
                contenidoView=[];
                contenido=modulos[k].contenido;
                agrupador="";
                fecha="";
                for(let i=0; i<contenido.length;i++){
                    if(agrupador!=contenido[i].agrupador || fecha!=contenido[i].fecha){
                        if(i>0){
                    
                            contenidoView.push(contenidoViewRow);
                        }
                        agrupador=contenido[i].agrupador;
                            fecha=contenido[i].fecha;
                        contenidoViewRow={
                            agrupador:contenido[i].agrupador,
                            fecha:contenido[i].fecha,
                            contenido:[]
                        };
                        
                    }
                    contenidoViewRow.contenido.push(contenido[i]);
                     
                }
                contenidoView.push(contenidoViewRow);
                 modulos[k].contenidoView=contenidoView;
            }
            
            this.setState({"curso":cursoDetalle});  
        })
        .catch(error=>{
          toastr.error(error);
        }); 
            }
       })
        .catch(error=>{
          toastr.error(error);
        }); 
        
        
        
	}
    
        
  onAcordionModulo=(id)=>{
         
         let curso=this.state.curso;
        let modulos=curso.modulos;
        for(let i=0; i<modulos.length; i++){
            if(modulos[i].id==id){
                if(modulos[i].activo==null)
                    modulos[i].activo=true;
                else
                    modulos[i].activo=!modulos[i].activo;
            }
        }
        this.setState({"curso":curso});
    }
    
  onVisible=(id)=>{
      
        let encontrado=false;
        let curso=this.state.curso;
        let modulos=curso.modulos;
        let contenido;
        
        for(let k=0; k<modulos.length && encontrado==false; k++){
            if(modulos[k].activo==true){
                contenido=modulos[k].contenido;
                
                for(let i=0; i<contenido.length; i++){
                    if(contenido[i].id==id){
                        encontrado=true;
                        this.setState({
                            "idContenido":contenido[i].id,
                            "idModulo":modulos[k].id,
                            "tituloContenido":contenido[i].titulo,
                            "idTipoContenido":contenido[i].idTipoContenido,
                            "urlContenido":contenido[i].archivo,
                            "idVisible":id,
                            "errorEx":null,
                            "visible":false,
                            "idFormulario":contenido[i].idFormulario,
                            "idModuloContenido":contenido[i].idModuloContenido,
                            "time":contenido[i].time,
                            "secondsTime":(contenido[i].time),
                            "tiempoVideo":contenido[i].tiempoVideo}
                            );
                        if(contenido[i].visto!=true){
                            
                            if(contenido[i].idTipoContenido!=28){
                                contenido[i].visto=true;
                            }
                            
                            let contenidoVisto={
                                idCurso:this.state.curso.id,
                                idContenido:contenido[i].idModuloContenido,
                                visto:1
                            };
                            
                            this.setState({contenidoVisto:contenidoVisto});
                             /*
                             if(contenido[i].idTipoContenido!=28){         
                                    validaApiToken(this).then( (userToken)=>{
                                        this.props.cursoActions.setVisto(contenidoVisto, userToken).then( ()=>{

                                        }).catch(error=>{
                                              toastr.error(error);
                                        }); 

                                    })
                             }
                             */

                        }


                        if(contenido[i].idTipoContenido==28){

                            validaApiToken(this).then( (userToken)=>{
                            this.props.formularioActions.getExamen(contenido[i].idFormulario, 0, userToken).then( examen=>{
                              
                                if(examen.id>0){
                                    examen.appLocale = this.state.appLocale;
                                    for(let i=0; i<examen.questions.length; i++){
                                        if(examen.questions[i].answerSelectionType=="single"){

                                                examen.questions[i].correctAnswer = examen.questions[i].correctAnswer[0].toString();
                                        }

                                    }
                                }


                                this.setState({"quiz":examen}); 
                                 })
                                .catch(error=>{
                                  toastr.error(error);
                                });    
                            
                                 

                        })

                    }
                        
                        
                    if(contenido[i].idTipoContenido==32){

                            validaApiToken(this).then( (userToken)=>{
                                
                                
                                this.props.crucigramapalabrasActions.getCrucigrama(contenido[i].juego, userToken).then( palabras=>{
                 
                                    this.convert(palabras);

                                 });
                                
                                
                                 })
                                .catch(error=>{
                                  toastr.error(error);
                                });    
                    }    
                        
        
                }

                
            }
        
        }
    }
      
  }
  
  
  convert=(palabras)=>{
        let datatmp = Object.assign({}, this.state.datatmp);
        let dataArray=[];
       
        dataArray = palabras;
        
        
        
        for(let i=0; i<dataArray.length;i++){
            
            if(dataArray[i].posicion=="across"){
                let tmp = dataArray[i];  
                datatmp.across[eval(dataArray[i].num)] = { clue: tmp.clue, answer: tmp.answer, row: tmp.row, col: tmp.col};
            }    
        }
        
        for(let i=0; i<dataArray.length;i++){
            if(dataArray[i].posicion=="down"){
                let tmp = dataArray[i];    
                datatmp.down[eval(dataArray[i].num)] = { clue: tmp.clue, answer: tmp.answer, row: tmp.row, col: tmp.col};
            }
        }
        
        this.setState({dataCrucigrama:datatmp});
        this.setState({dataArray:palabras});
      
    }
  
  
  setQuizResult = (obj) => {
      let objeto = Object.assign({},this.state.examenSave);

      if(obj.totalPoints>0){
        
        objeto.cadena = Object.assign({},obj);  
        objeto.idFormulario = this.state.idFormulario;
        objeto.idModuloContenido = this.state.idModuloContenido;
        objeto.idCurso = this.state.curso.id;
        objeto.correctPoints = obj.correctPoints;
        objeto.numberOfCorrectAnswers = obj.numberOfCorrectAnswers;
        objeto.numberOfIncorrectAnswers = obj.numberOfIncorrectAnswers;
        objeto.numberOfQuestions = obj.numberOfQuestions;
        objeto.totalPoints = obj.totalPoints;  
            
      }
  }
  
  onSeek=(segundos)=>{
      //console.log("onSeek: "+segundos);
  }
  
  onVideoTerminado=()=>{
      
        let contenidoVisto={
            idCurso:this.state.curso.id,
            idContenido:this.state.idModuloContenido,
            tiempoVideo:Math.round(this.state.duration)
        };
     
        renuevaToken(this, contenidoVisto);
      
  }
  
  
  videoProgreso=(progreso)=>{      
         
      if(this.state.tiempoVideo<= Math.floor(progreso.playedSeconds)){
          let avance=progreso.playedSeconds-this.state.tiempoVideo;
          if(avance>5)
          {
              toastr.error("Avance no permitido");
          }else{
              if(Math.floor(progreso.playedSeconds)>this.state.tiempoVideo){
                this.setState({"tiempoVideo":Math.floor(progreso.playedSeconds)});
              }  
          }
          
      }
      
      if((Math.floor(progreso.playedSeconds) % 180) ==0 && Math.floor(progreso.playedSeconds)!=0){
            
            
                let contenidoVisto={
                    idCurso:this.state.curso.id,
                    idContenido:this.state.idModuloContenido,
                    tiempoVideo:Math.floor(progreso.playedSeconds)
                };
                
                renuevaToken(this, contenidoVisto);
                
                    
      }
      
  }
  
  
  renderCustomResultPage = (obj) => {
      let quiz = this.state.quiz;
        return (
            <Segment  style={{width: '100%', height:'80%'}}>
                <Header as='h3'>{quiz.quizTitle}</Header>

                Total de preguntas:{obj.numberOfQuestions}<br/>
                Correctas:{obj.numberOfCorrectAnswers}<br/>
                Incorrectas:{obj.numberOfIncorrectAnswers}<br/>
                Total de puntos posibles:{obj.totalPoints}<br/>
                Total obtenido:{obj.correctPoints}<br/>



            </Segment>    
        );
  }
  
  handleClick=(url, id)=>{
    /*  
    let curso=this.state.curso;
    let modulos=curso.modulos;
    let contenido;
      
      for(let k=0; k<modulos.length; k++){
            if(modulos[k].activo==true){
                contenido=modulos[k].contenido;
                
                for(let i=0; i<contenido.length; i++){
                    if(contenido[i].id==id){
                        if(contenido[i].visto!=true){
                            contenido[i].visto=true;
                            let contenidoVisto={
                                idCurso:this.state.curso.id,
                                idContenido:contenido[i].idModuloContenido,
                                visto:10
                            };
                        }
                    }
                }
            }
      }
      */
       window.open(url);
      
  }
  
  handleStateNewComment=(id)=>{
       
        this.setState({botonComentario:true});
        
        //console.log(this.state.textComment.length);
      
        if(this.state.textComment.length>10){
      
        let nuevoComment = {text: this.state.textComment, comId:id};
        let comentarios=[];

        comentarios.foro =[];
        comentarios.foro.push(nuevoComment);
        comentarios.contenidoId = this.state.contenidoId;
        comentarios.idCurso=this.props.id;
        comentarios.idModuloContenido = this.state.idModuloContenido;
       
    
        validaApiToken(this).then( ()=>{
            
                /*
                this.props.comentariosActions.saveComment(comentarios, this.props.user).then( comentarios=>{
                        let com = this.state.comentarios;    
                        this.setState({reply:0});
                    
                        if(id==0){
                             comentarios.foro[0].value = RichTextEditor.createValueFromString(comentarios.foro[0].text,'html');
                            com.push(comentarios.foro[0]);
                        }else{
                            let comIndex = com.findIndex(com=>com.comId==comentarios.foro[0].comId);
                            comentarios.foro[0].replies[0].value = RichTextEditor.createValueFromString(comentarios.foro[0].replies[0].text,'html');
                            com[comIndex].replies.push(comentarios.foro[0].replies[0]);
                            
                        }
                        this.setState({value: RichTextEditor.createEmptyValue()});
                        this.setState({textComment:""});
                        this.setState({comentarios:com});
                        this.setState({botonComentario:false});
                    
                     })
                    .catch(error=>{
                      toastr.error(error);
                });
                */
        })
        .catch(error=>{
          toastr.error(error);
        });
       
        }else{
            
            toastr.error("Debe capturar un comentario");
            
        }
  }
  
  addText=(event, data)=>{
       
  }
  
  
   handleState=(value)=>{
        
        this.setState({comentarios:value})
        
        let comentarios=[];
       
        for(let i=0; i<value.length; i++){
            
            if(isNaN(value[i].comId)){
               value[i].comId=0;
            }
            
            if(value[i].replies){
                
                for(let j=0; j<value[i].replies.length; j++){
                    
                    if(isNaN(value[i].replies[j].comId)){
                           value[i].replies[j].comId=0;
                        } 
                    
                }
                
            }
            
        }
        
        comentarios.foro = value;
        comentarios.contenidoId = this.state.contenidoId;
        comentarios.idCurso=this.props.id;
        comentarios.idModuloContenido = this.state.idModuloContenido;
       
        comentarios.id = this.state.idComentarios;
               
    }
   
  
  regresar=()=>{
   
      let curso=this.state.curso;
      let modulos=curso.modulos;
      let quiz = {};
      let errorEx=null;
      quiz.id = 0;
      
      
      let moduloIndex = modulos.findIndex(modulo=>modulo.id==this.state.idModulo);
      
      let contenidoIndex = modulos[moduloIndex].contenido.findIndex(cont=>cont.id==this.state.idContenido);
      
      
      if(curso.modulos[moduloIndex].contenido[contenidoIndex].tiempoVideo < this.state.tiempoVideo){
          curso.modulos[moduloIndex].contenido[contenidoIndex].tiempoVideo = this.state.tiempoVideo;
      }
      
      this.setState({
                    "visible":true, "curso":curso, "quiz":quiz });
      this.setState({err:errorEx});
      
  }
  
  
    showModalComents=(id, idModuloContenido)=>{

    
        
    }
    
    goBack=()=>{
         this.props.navigate(-1);
    }
    
    
    handleDuration = (duration) => {
            this.setState({duration:duration});
            if(this.state.secondsTime!=null){
                if(this.state.secondsTime!=Math.round(duration)){
                    
                    let contenido={};
                    contenido.id = this.state.idContenido;
                    contenido.tiempo = Math.round(duration);
                    
                    validaApiToken(this).then( (userToken)=>{
                        //this.props.contenidoActions.saveTime(contenido,userToken).then(() => {

                    });
                    
                }            
            }
    }
    
    saveExamen=()=>{

        
    }
    
    onReply=(id)=>{
      
    }
    
    
    onEditar=(id)=>{
      
    }
    
    
     onContentEdit=(value)=>{
        
    }
     
     
    onEditarReply=(comentId, id)=>{
        
    }
    
    
     onReplyEdit=(value)=>{
        
    } 
     
    closeModalComents=(id)=>{
  
    } 
     
     
     onSaveReply=()=>{
        
        let reply = Object.assign({}, this.state.comentarios[this.state.indexComentario].replies[this.state.indexReply]);
      
        validaApiToken(this).then( (userToken)=>{

             
        });
        
    } 
     
     
    onSaveComent=()=>{
        
        let comentario = Object.assign({}, this.state.comentarios[this.state.indexComentario]);
        validaApiToken(this).then( (userToken)=>{

             
        });     
    }
    
    handleComentarioDelete=(comentarioId)=>{
        
         validaApiToken(this).then( (userToken)=>{

        });
        
        
    }
    
    handleReplyDelete=(comentarioId, id)=>{
    
      
        validaApiToken(this).then( (userToken)=>{

               
        });
    }
    
    onCancelReply=()=>{
       
    }
   
    setContent=(value)=>{
     
        
    }
    
    
    
    render() {
        let margenes=getMargenes(this.props.showSidebarIzquierda, this.props.sidebarIzquierda);


		return (
            <Segment>
                 
                <CursoView
            
                    onSeek={this.onSeek}
                    curso={this.state.curso}
                    onAcordionModulo={this.onAcordionModulo}
                    modulos={this.state.modulos}
                    strings={this.props.strings}
                    idTipoContenido={this.state.idTipoContenido}
                    urlContenido={this.state.urlContenido}
                    tituloContenido={this.state.tituloContenido}
                    ajaxCallInProgress={this.props.ajaxCallInProgress}
                    permisos={this.state.permisos}
                    visible={this.state.visible}
                    onVisible={this.onVisible}
                    id={this.state.id}
                    regresar={this.regresar}
                    quiz={this.state.quiz}
                    setQuizResult={this.setQuizResult}
                    renderCustomResultPage={this.renderCustomResultPage}
                    comentarios={this.state.comentarios}
                    showModalComents={this.showModalComents}
                    fechaActual={this.state.fechaActual}
                    handleClick={this.handleClick}
                    videoProgreso={this.videoProgreso}
                    onDuration={this.handleDuration}
                    videoTerminado={this.onVideoTerminado}
                    fechaComentario={this.state.fechaComentario}
                    errorExamen={this.state.err}
                    saveExamen={this.saveExamen} 
                    dataCrucigrama={this.state.dataCrucigrama}
                    dataArray={this.state.dataArray}
                    goBack={this.goBack}
                />
   

            </Segment> 
            
		);
	}
    
}

            
            
function mapStateToProps(state, ownProps){
    
    return {
        showSidebarIzquierda: state.showSidebarIzquierda,
        sidebarIzquierda: state.sidebarIzquierda,
        ajaxCallInProgress:state.ajaxCallInProgress,
        color:state.color,
        form:state.form,
        color:state.color,
        
        strings:state.strings,
        idioma:state.idioma,
        user:state.user
    }

}


function mapDispatchToProps(dispatch){

	return { 
        menuActions:bindActionCreators(menuActions, dispatch),
        paginaActions: bindActionCreators(paginaActions, dispatch),
        infoActions: bindActionCreators(infoActions, dispatch),
        cursoActions: bindActionCreators(cursoActions, dispatch),
        userActions: bindActionCreators(userActions, dispatch),
        showSidebarIzquierdaActions: bindActionCreators(showSidebarIzquierdaActions, dispatch),
        formularioActions: bindActionCreators(formularioActions, dispatch),
        resultadoexamenActions: bindActionCreators(resultadoexamenActions, dispatch),
        comentariosActions: bindActionCreators(comentariosActions, dispatch),
        contenidoActions: bindActionCreators(contenidoActions, dispatch),
        crucigramapalabrasActions: bindActionCreators(crucigramapalabrasActions, dispatch),
 	};
}

function Parametros(){
    const {id} = useParams();
    const location = useLocation();
    return{
        id
    }
}

export default connect (mapStateToProps, mapDispatchToProps)(withRouter(ManageCursoView));